import styled from "@emotion/styled";
import { Error, Info, CheckCircle } from "@mui/icons-material";

import { commonColors } from "application/theme";

export const SuccessIcon = styled(CheckCircle)`
  width: 20px;
  height: 20px;
  color: ${commonColors.green700};
`;

export const ErrorIcon = styled(Error)`
  width: 20px;
  height: 20px;
  color: ${commonColors.red700};
`;

export const InfoIcon = styled(Info)`
  width: 20px;
  height: 20px;
  color: ${commonColors.blue700};
`;

export const WarningIcon = styled(Info)`
  width: 20px;
  height: 20px;
  color: ${commonColors.orange_700};
`;
